var map = {
	"./banner-77-travel-m.jpg": 43289,
	"./banner-77-travel.jpg": 3017,
	"./central/ang-thong/ang-thong-1.jpg": 47229,
	"./central/ang-thong/ang-thong-2.jpg": 89431,
	"./central/ang-thong/ang-thong-3.jpg": 98617,
	"./central/ang-thong/ang-thong-4.jpg": 72877,
	"./central/ang-thong/ang-thong-5.jpg": 85803,
	"./central/ang-thong/ang-thong-thumb.jpg": 89362,
	"./central/ayutthaya/ayutthaya-1.jpg": 69844,
	"./central/ayutthaya/ayutthaya-2.jpg": 3449,
	"./central/ayutthaya/ayutthaya-3.jpg": 16101,
	"./central/ayutthaya/ayutthaya-4.jpg": 91799,
	"./central/ayutthaya/ayutthaya-5.jpg": 86425,
	"./central/ayutthaya/ayutthaya-thumb.jpg": 78641,
	"./central/bangkok/bangkok-1.jpg": 91846,
	"./central/bangkok/bangkok-2.jpg": 1740,
	"./central/bangkok/bangkok-3.jpg": 37425,
	"./central/bangkok/bangkok-4.jpg": 49934,
	"./central/bangkok/bangkok-5.jpg": 50348,
	"./central/bangkok/bangkok-thumb.jpg": 86478,
	"./central/chainat/chainat-1.jpg": 46706,
	"./central/chainat/chainat-2.jpg": 78299,
	"./central/chainat/chainat-3.jpg": 52467,
	"./central/chainat/chainat-4.jpg": 67609,
	"./central/chainat/chainat-5.jpg": 3105,
	"./central/chainat/chainat-thumb.jpg": 81105,
	"./central/kanchanaburi/kanchanaburi-1.jpg": 31336,
	"./central/kanchanaburi/kanchanaburi-2.jpg": 16832,
	"./central/kanchanaburi/kanchanaburi-3.jpg": 90142,
	"./central/kanchanaburi/kanchanaburi-4.jpg": 11362,
	"./central/kanchanaburi/kanchanaburi-5.jpg": 9904,
	"./central/kanchanaburi/kanchanaburi-thumb.jpg": 23361,
	"./central/lopburi/lopburi-1.jpg": 66549,
	"./central/lopburi/lopburi-2.jpg": 85718,
	"./central/lopburi/lopburi-3.jpg": 60679,
	"./central/lopburi/lopburi-4.jpg": 13709,
	"./central/lopburi/lopburi-5.jpg": 28393,
	"./central/lopburi/lopburi-thumb.jpg": 13454,
	"./central/nakhon-pathom/nakhon-pathom-01.jpg": 66335,
	"./central/nakhon-pathom/nakhon-pathom-02.jpg": 89992,
	"./central/nakhon-pathom/nakhon-pathom-03.jpg": 12385,
	"./central/nakhon-pathom/nakhon-pathom-04.jpg": 60167,
	"./central/nakhon-pathom/nakhon-pathom-05.jpg": 30489,
	"./central/nakhon-pathom/nakhon-pathom-thumb.jpg": 21868,
	"./central/nonthaburi/nonthaburi-1.jpg": 52490,
	"./central/nonthaburi/nonthaburi-2.jpg": 54151,
	"./central/nonthaburi/nonthaburi-3.jpg": 45159,
	"./central/nonthaburi/nonthaburi-4.jpg": 21206,
	"./central/nonthaburi/nonthaburi-5.jpg": 99556,
	"./central/nonthaburi/nonthaburi-thumb.jpg": 39312,
	"./central/pathum-thani/pathum-thani-1.jpg": 86899,
	"./central/pathum-thani/pathum-thani-2.jpg": 45905,
	"./central/pathum-thani/pathum-thani-3.jpg": 94084,
	"./central/pathum-thani/pathum-thani-thumb.jpg": 44599,
	"./central/phetchaburi/phetchaburi -1.jpg": 82831,
	"./central/phetchaburi/phetchaburi -2.jpg": 32565,
	"./central/phetchaburi/phetchaburi -3.jpg": 78437,
	"./central/phetchaburi/phetchaburi-thumb.jpg": 10190,
	"./central/prachuap-khiri-khan/prachuap-khiri-khan-1.jpg": 42411,
	"./central/prachuap-khiri-khan/prachuap-khiri-khan-thumb.jpg": 42902,
	"./central/ratchaburi/ratchaburi-1.jpg": 45851,
	"./central/ratchaburi/ratchaburi-2.jpg": 90583,
	"./central/ratchaburi/ratchaburi-3.jpg": 14315,
	"./central/ratchaburi/ratchaburi-4.jpg": 14977,
	"./central/ratchaburi/ratchaburi-5.jpg": 41090,
	"./central/ratchaburi/ratchaburi-thumb.jpg": 88480,
	"./central/samut-sakhon/samut-sakhon-1.jpg": 65744,
	"./central/samut-sakhon/samut-sakhon-2.jpg": 79890,
	"./central/samut-sakhon/samut-sakhon-3.jpg": 72123,
	"./central/samut-sakhon/samut-sakhon-thumb.jpg": 23939,
	"./central/samut-songkhram/samut-songkhram-1.jpg": 39735,
	"./central/samut-songkhram/samut-songkhram-2.jpg": 60414,
	"./central/samut-songkhram/samut-songkhram-3.jpg": 49333,
	"./central/samut-songkhram/samut-songkhram-4.jpg": 98854,
	"./central/samut-songkhram/samut-songkhram-thumb.jpg": 43680,
	"./central/saraburi/saraburi-1.jpg": 73731,
	"./central/saraburi/saraburi-2.jpg": 26495,
	"./central/saraburi/saraburi-3.jpg": 66698,
	"./central/saraburi/saraburi-4.jpg": 88168,
	"./central/saraburi/saraburi-5.jpg": 90897,
	"./central/saraburi/saraburi-thumb.jpg": 82819,
	"./central/sing-buri/sing-buri-1.jpg": 44305,
	"./central/sing-buri/sing-buri-2.jpg": 55949,
	"./central/sing-buri/sing-buri-3.jpg": 32606,
	"./central/sing-buri/sing-buri-4.jpg": 28664,
	"./central/sing-buri/sing-buri-5.jpg": 48174,
	"./central/sing-buri/sing-buri-thumb.jpg": 9650,
	"./central/suphan-buri/suphan-buri-1.jpg": 20975,
	"./central/suphan-buri/suphan-buri-2.jpg": 8941,
	"./central/suphan-buri/suphan-buri-3.jpg": 70921,
	"./central/suphan-buri/suphan-buri-4.jpg": 18851,
	"./central/suphan-buri/suphan-buri-thumb.jpg": 31925,
	"./eastern/chachoengsao/chachoengsao-1.jpg": 67235,
	"./eastern/chachoengsao/chachoengsao-2.jpg": 13529,
	"./eastern/chachoengsao/chachoengsao-3.jpg": 23090,
	"./eastern/chachoengsao/chachoengsao-thumb.jpg": 82160,
	"./eastern/chanthaburi/chanthaburi-1.jpg": 63602,
	"./eastern/chanthaburi/chanthaburi-2.jpg": 50301,
	"./eastern/chanthaburi/chanthaburi-3.jpg": 9234,
	"./eastern/chanthaburi/chanthaburi-4.jpg": 91579,
	"./eastern/chanthaburi/chanthaburi-5.jpg": 22281,
	"./eastern/chanthaburi/chanthaburi-thumb.jpg": 64811,
	"./eastern/chonburi/chonburi-1.jpg": 28106,
	"./eastern/chonburi/chonburi-2.jpg": 69593,
	"./eastern/chonburi/chonburi-3.jpg": 25869,
	"./eastern/chonburi/chonburi-thumb.jpg": 97521,
	"./eastern/nakhonnayok/nakhonnayok-1.jpg": 31561,
	"./eastern/nakhonnayok/nakhonnayok-2.jpg": 59281,
	"./eastern/nakhonnayok/nakhonnayok-3.jpg": 36475,
	"./eastern/nakhonnayok/nakhonnayok-4.jpg": 5367,
	"./eastern/nakhonnayok/nakhonnayok-5.jpg": 83671,
	"./eastern/nakhonnayok/nakhonnayok-thumb.jpg": 95561,
	"./eastern/prachinburi/prachinburi-1.jpg": 54116,
	"./eastern/prachinburi/prachinburi-2.jpg": 25242,
	"./eastern/prachinburi/prachinburi-3.jpg": 84058,
	"./eastern/prachinburi/prachinburi-4.jpg": 68837,
	"./eastern/prachinburi/prachinburi-5.jpg": 28518,
	"./eastern/prachinburi/prachinburi-thumb.jpg": 4103,
	"./eastern/rayong/rayong-1.jpg": 39293,
	"./eastern/rayong/rayong-2.jpg": 20466,
	"./eastern/rayong/rayong-3.jpg": 69101,
	"./eastern/rayong/rayong-thumb.jpg": 16386,
	"./eastern/sakaeo/sakaeo-1.jpg": 24081,
	"./eastern/sakaeo/sakaeo-2.jpg": 17177,
	"./eastern/sakaeo/sakaeo-3.jpg": 5768,
	"./eastern/sakaeo/sakaeo-4.jpg": 48644,
	"./eastern/sakaeo/sakaeo-5.jpg": 35044,
	"./eastern/sakaeo/sakaeo-thumb.jpg": 16347,
	"./eastern/sakeaw/sakaeo-1.jpg": 73854,
	"./eastern/sakeaw/sakaeo-2.jpg": 34850,
	"./eastern/sakeaw/sakaeo-3.jpg": 8683,
	"./eastern/sakeaw/sakaeo-4.jpg": 56010,
	"./eastern/sakeaw/sakaeo-5.jpg": 48035,
	"./eastern/sakeaw/sakaeo-thumb.jpg": 12880,
	"./eastern/samutprakan/samutprakan-1.jpg": 67231,
	"./eastern/samutprakan/samutprakan-2.jpg": 83974,
	"./eastern/samutprakan/samutprakan-3.jpg": 8320,
	"./eastern/samutprakan/samutprakan-thumb.jpg": 22829,
	"./eastern/trat/trat-1.jpg": 49901,
	"./eastern/trat/trat-2.jpg": 533,
	"./eastern/trat/trat-3.jpg": 46363,
	"./eastern/trat/trat-4.jpg": 42828,
	"./eastern/trat/trat-5.jpg": 73691,
	"./eastern/trat/trat-thumb.jpg": 66732,
	"./north/chiangmai/chiangmai-1.jpg": 16757,
	"./north/chiangmai/chiangmai-2.jpg": 1060,
	"./north/chiangmai/chiangmai-3.jpg": 98860,
	"./north/chiangmai/chiangmai-4.jpg": 91154,
	"./north/chiangmai/chiangmai-5.jpg": 51111,
	"./north/chiangmai/chiangmai-thumb.jpg": 2568,
	"./north/chiangrai/chiangrai-1.jpg": 96840,
	"./north/chiangrai/chiangrai-2.jpg": 88310,
	"./north/chiangrai/chiangrai-3.jpg": 53297,
	"./north/chiangrai/chiangrai-4.jpg": 62861,
	"./north/chiangrai/chiangrai-5.jpg": 2031,
	"./north/chiangrai/chiangrai-thumb.jpg": 76585,
	"./north/kamphaeng-phet/kamphaeng-phet-1.jpg": 7200,
	"./north/kamphaeng-phet/kamphaeng-phet-2.jpg": 41570,
	"./north/kamphaeng-phet/kamphaeng-phet-3.jpg": 3448,
	"./north/kamphaeng-phet/kamphaeng-phet-4.jpg": 13498,
	"./north/kamphaeng-phet/kamphaeng-phet-5.jpg": 14239,
	"./north/kamphaeng-phet/kamphaeng-phet-thumb.jpg": 97242,
	"./north/lampang/lampang-1.jpg": 3943,
	"./north/lampang/lampang-2.jpg": 80264,
	"./north/lampang/lampang-3.jpg": 86558,
	"./north/lampang/lampang-4.jpg": 16831,
	"./north/lampang/lampang-5.jpg": 35915,
	"./north/lampang/lampang-thumb.jpg": 3690,
	"./north/lamphun/lamphun-1.jpg": 81190,
	"./north/lamphun/lamphun-2.jpg": 42095,
	"./north/lamphun/lamphun-3.jpg": 22206,
	"./north/lamphun/lamphun-4.jpg": 17155,
	"./north/lamphun/lamphun-thumb.jpg": 15338,
	"./north/mae-hong-son/mae-hong-son-1.jpg": 44048,
	"./north/mae-hong-son/mae-hong-son-2.jpg": 50305,
	"./north/mae-hong-son/mae-hong-son-3.jpg": 67089,
	"./north/mae-hong-son/mae-hong-son-4.jpg": 48898,
	"./north/mae-hong-son/mae-hong-son-5.jpg": 94851,
	"./north/mae-hong-son/mae-hong-son-thumb.jpg": 44424,
	"./north/nakhon-sawan/nakhon-sawan-1.jpg": 92184,
	"./north/nakhon-sawan/nakhon-sawan-2.jpg": 9481,
	"./north/nakhon-sawan/nakhon-sawan-3.jpg": 69595,
	"./north/nakhon-sawan/nakhon-sawan-4.jpg": 75291,
	"./north/nakhon-sawan/nakhon-sawan-5.jpg": 99247,
	"./north/nakhon-sawan/nakhon-sawan-thumb.jpg": 44295,
	"./north/nan/nan-1.jpg": 52080,
	"./north/nan/nan-2.jpg": 71706,
	"./north/nan/nan-3.jpg": 80880,
	"./north/nan/nan-4.jpg": 9700,
	"./north/nan/nan-thumb.jpg": 89583,
	"./north/phayao/phayao-1.jpg": 51216,
	"./north/phayao/phayao-2.jpg": 49753,
	"./north/phayao/phayao-3.jpg": 33362,
	"./north/phayao/phayao-4.jpg": 63217,
	"./north/phayao/phayao-5.jpg": 11683,
	"./north/phayao/phayao-thumb.jpg": 98720,
	"./north/phetchabun/phetchabun-1.jpg": 28104,
	"./north/phetchabun/phetchabun-2.jpg": 58656,
	"./north/phetchabun/phetchabun-3.jpg": 71320,
	"./north/phetchabun/phetchabun-4.jpg": 25046,
	"./north/phetchabun/phetchabun-5.jpg": 20399,
	"./north/phetchabun/phetchabun-thumb.jpg": 4472,
	"./north/phichit/phichit-1.jpg": 82331,
	"./north/phichit/phichit-2.jpg": 40577,
	"./north/phichit/phichit-3.jpg": 89797,
	"./north/phichit/phichit-4.jpg": 2575,
	"./north/phichit/phichit-5.jpg": 35380,
	"./north/phichit/phichit-thumb.jpg": 65522,
	"./north/phitsanulok/phitsanulok-1.jpg": 19508,
	"./north/phitsanulok/phitsanulok-2.jpg": 47868,
	"./north/phitsanulok/phitsanulok-3.jpg": 98600,
	"./north/phitsanulok/phitsanulok-thumb.jpg": 95257,
	"./north/phrae/phrae-1.jpg": 7655,
	"./north/phrae/phrae-2.jpg": 33558,
	"./north/phrae/phrae-3.jpg": 19505,
	"./north/phrae/phrae-4.jpg": 47572,
	"./north/phrae/phrae-5.jpg": 47060,
	"./north/phrae/phrae-thumb.jpg": 84968,
	"./north/sukhothai/sukhothai-1.jpg": 87673,
	"./north/sukhothai/sukhothai-2.jpg": 28577,
	"./north/sukhothai/sukhothai-3.jpg": 27873,
	"./north/sukhothai/sukhothai-4.jpg": 50169,
	"./north/sukhothai/sukhothai-5.jpg": 86339,
	"./north/sukhothai/sukhothai-thumb.jpg": 11353,
	"./north/tak/tak-1.jpg": 27826,
	"./north/tak/tak-2.jpg": 20197,
	"./north/tak/tak-3.jpg": 98327,
	"./north/tak/tak-4.jpg": 53919,
	"./north/tak/tak-5.jpg": 28594,
	"./north/tak/tak-thumb.jpg": 23547,
	"./north/uthai-thani/uthai-thani-1.jpg": 21438,
	"./north/uthai-thani/uthai-thani-2.jpg": 536,
	"./north/uthai-thani/uthai-thani-3.jpg": 90954,
	"./north/uthai-thani/uthai-thani-4.jpg": 18697,
	"./north/uthai-thani/uthai-thani-5.jpg": 64321,
	"./north/uthai-thani/uthai-thani-thumb.jpg": 40281,
	"./north/uttaradit/uttaradit-1.jpg": 40931,
	"./north/uttaradit/uttaradit-2.jpg": 40114,
	"./north/uttaradit/uttaradit-3.jpg": 36541,
	"./north/uttaradit/uttaradit-4.jpg": 40055,
	"./north/uttaradit/uttaradit-thumb.jpg": 11308,
	"./northeast/amnat-charoen/amnat-charoen-1.jpg": 22798,
	"./northeast/amnat-charoen/amnat-charoen-2.jpg": 94480,
	"./northeast/amnat-charoen/amnat-charoen-3.jpg": 49494,
	"./northeast/amnat-charoen/amnat-charoen-4.jpg": 6149,
	"./northeast/amnat-charoen/amnat-charoen-thumb.jpg": 51702,
	"./northeast/bueng-kan/bueng-kan-1.jpg": 92038,
	"./northeast/bueng-kan/bueng-kan-2.jpg": 48641,
	"./northeast/bueng-kan/bueng-kan-3.jpg": 12618,
	"./northeast/bueng-kan/bueng-kan-4.jpg": 37567,
	"./northeast/bueng-kan/bueng-kan-thumb.jpg": 81726,
	"./northeast/buriram/buriram-1.jpg": 85992,
	"./northeast/buriram/buriram-2.jpg": 27511,
	"./northeast/buriram/buriram-3.jpg": 28596,
	"./northeast/buriram/buriram-4.jpg": 26539,
	"./northeast/buriram/buriram-5.jpg": 55372,
	"./northeast/buriram/buriram-thumb.jpg": 18145,
	"./northeast/chaiyaphum/chaiyaphum-1.jpg": 42170,
	"./northeast/chaiyaphum/chaiyaphum-2.jpg": 2390,
	"./northeast/chaiyaphum/chaiyaphum-3.jpg": 41935,
	"./northeast/chaiyaphum/chaiyaphum-4.jpg": 76715,
	"./northeast/chaiyaphum/chaiyaphum-5.jpg": 18290,
	"./northeast/chaiyaphum/chaiyaphum-thumb.jpg": 53886,
	"./northeast/kalasin/kalasin-1.jpg": 23527,
	"./northeast/kalasin/kalasin-2.jpg": 11622,
	"./northeast/kalasin/kalasin-3.jpg": 7309,
	"./northeast/kalasin/kalasin-4.jpg": 26528,
	"./northeast/kalasin/kalasin-5.jpg": 86634,
	"./northeast/kalasin/kalasin-thumb.jpg": 34014,
	"./northeast/khonkaen/khonkaen-1.jpg": 7873,
	"./northeast/khonkaen/khonkaen-2.jpg": 65436,
	"./northeast/khonkaen/khonkaen-3.jpg": 55911,
	"./northeast/khonkaen/khonkaen-4.jpg": 73670,
	"./northeast/khonkaen/khonkaen-thumb.jpg": 60483,
	"./northeast/loei/loei-1.jpg": 9698,
	"./northeast/loei/loei-2.jpg": 95310,
	"./northeast/loei/loei-3.jpg": 85283,
	"./northeast/loei/loei-thumb.jpg": 36167,
	"./northeast/maha-sarakham/maha-sarakham-1.jpg": 30365,
	"./northeast/maha-sarakham/maha-sarakham-2.jpg": 60543,
	"./northeast/maha-sarakham/maha-sarakham-3.jpg": 35266,
	"./northeast/maha-sarakham/maha-sarakham-4.jpg": 57448,
	"./northeast/maha-sarakham/maha-sarakham-5.jpg": 93601,
	"./northeast/maha-sarakham/maha-sarakham-thumb.jpg": 865,
	"./northeast/mukdahan/mukdahan-1.jpg": 15418,
	"./northeast/mukdahan/mukdahan-2.jpg": 56754,
	"./northeast/mukdahan/mukdahan-3.jpg": 41012,
	"./northeast/mukdahan/mukdahan-4.jpg": 31725,
	"./northeast/mukdahan/mukdahan-5.jpg": 86730,
	"./northeast/mukdahan/mukdahan-thumb.jpg": 91356,
	"./northeast/nakhon-phanom/nakhon-phanom-1.jpg": 75680,
	"./northeast/nakhon-phanom/nakhon-phanom-2.jpg": 63641,
	"./northeast/nakhon-phanom/nakhon-phanom-3.jpg": 5300,
	"./northeast/nakhon-phanom/nakhon-phanom-4.jpg": 69265,
	"./northeast/nakhon-phanom/nakhon-phanom-5.jpg": 53402,
	"./northeast/nakhon-phanom/nakhon-phanom-thumb.jpg": 88832,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-1.jpg": 13937,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-2.jpg": 34257,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-3.jpg": 55677,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-4.jpg": 46885,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-5.jpg": 45345,
	"./northeast/nakhon-ratchasima/nakhon-ratchasima-thumb.jpg": 64438,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-1.jpg": 8881,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-2.jpg": 87672,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-3.jpg": 72048,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-4.jpg": 43613,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-5.jpg": 13870,
	"./northeast/nong-bua-lamphu/nong-bua-lamphu-thumb.jpg": 79821,
	"./northeast/nong-khai/nong-khai-1.jpg": 67682,
	"./northeast/nong-khai/nong-khai-2.jpg": 26047,
	"./northeast/nong-khai/nong-khai-3.jpg": 49073,
	"./northeast/nong-khai/nong-khai-4.jpg": 44064,
	"./northeast/nong-khai/nong-khai-thumb.jpg": 52164,
	"./northeast/roiet/roiet-1.jpg": 74300,
	"./northeast/roiet/roiet-2.jpg": 89352,
	"./northeast/roiet/roiet-3.jpg": 83508,
	"./northeast/roiet/roiet-4.jpg": 11183,
	"./northeast/roiet/roiet-5.jpg": 16205,
	"./northeast/roiet/roiet-thumb.jpg": 86473,
	"./northeast/sakon-nakhon/sakon-nakhon-1.jpg": 41499,
	"./northeast/sakon-nakhon/sakon-nakhon-2.jpg": 97914,
	"./northeast/sakon-nakhon/sakon-nakhon-3.jpg": 76294,
	"./northeast/sakon-nakhon/sakon-nakhon-4.jpg": 46548,
	"./northeast/sakon-nakhon/sakon-nakhon-5.jpg": 1459,
	"./northeast/sakon-nakhon/sakon-nakhon-thumb.jpg": 42702,
	"./northeast/sisaket/sisaket-1.jpg": 63414,
	"./northeast/sisaket/sisaket-2.jpg": 59638,
	"./northeast/sisaket/sisaket-3.jpg": 82617,
	"./northeast/sisaket/sisaket-thumb.jpg": 25644,
	"./northeast/surin/surin-1.jpg": 62088,
	"./northeast/surin/surin-2.jpg": 13555,
	"./northeast/surin/surin-3.jpg": 96792,
	"./northeast/surin/surin-thumb.jpg": 5641,
	"./northeast/ubon-ratchathani/ubon-ratchathani-1.jpg": 32439,
	"./northeast/ubon-ratchathani/ubon-ratchathani-2.jpg": 28322,
	"./northeast/ubon-ratchathani/ubon-ratchathani-3.jpg": 47044,
	"./northeast/ubon-ratchathani/ubon-ratchathani-4.jpg": 78052,
	"./northeast/ubon-ratchathani/ubon-ratchathani-5.jpg": 18366,
	"./northeast/ubon-ratchathani/ubon-ratchathani-thumb.jpg": 62338,
	"./northeast/udon-thani/udon-thani-1.jpg": 3759,
	"./northeast/udon-thani/udon-thani-2.jpg": 70666,
	"./northeast/udon-thani/udon-thani-3.jpg": 43010,
	"./northeast/udon-thani/udon-thani-4.jpg": 88598,
	"./northeast/udon-thani/udon-thani-5.jpg": 64072,
	"./northeast/udon-thani/udon-thani-thumb.jpg": 12883,
	"./northeast/yasothon/yasothon-1.jpg": 19041,
	"./northeast/yasothon/yasothon-2.jpg": 53558,
	"./northeast/yasothon/yasothon-3.jpg": 80177,
	"./northeast/yasothon/yasothon-4.jpg": 84170,
	"./northeast/yasothon/yasothon-5.jpg": 85551,
	"./northeast/yasothon/yasothon-thumb.jpg": 41053,
	"./south/chumphon/chumphon-1.jpg": 72050,
	"./south/chumphon/chumphon-2.jpg": 71669,
	"./south/chumphon/chumphon-3.jpg": 76691,
	"./south/chumphon/chumphon-4.jpg": 31379,
	"./south/chumphon/chumphon-5.jpg": 14714,
	"./south/chumphon/chumphon-thumb.jpg": 75826,
	"./south/krabi/krabi-1.jpg": 47653,
	"./south/krabi/krabi-2.jpg": 67133,
	"./south/krabi/krabi-thumb.jpg": 29895,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-1.jpg": 84469,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-2.jpg": 24017,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-3.jpg": 71269,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-4.jpg": 61784,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-5.jpg": 12634,
	"./south/nakhon-si-thammarat/nakhon-si-thammarat-thumb.jpg": 54533,
	"./south/narathiwat/narathiwat-1.jpg": 12548,
	"./south/narathiwat/narathiwat-2.jpg": 41787,
	"./south/narathiwat/narathiwat-3.jpg": 83689,
	"./south/narathiwat/narathiwat-4.jpg": 71231,
	"./south/narathiwat/narathiwat-5.jpg": 36586,
	"./south/narathiwat/narathiwat-thumb.jpg": 75049,
	"./south/pattani/pattani-1.jpg": 92344,
	"./south/pattani/pattani-2.jpg": 53480,
	"./south/pattani/pattani-3.jpg": 22120,
	"./south/pattani/pattani-4.jpg": 2663,
	"./south/pattani/pattani-thumb.jpg": 7622,
	"./south/phangnga/phangnga-1.jpg": 62594,
	"./south/phangnga/phangnga-2.jpg": 10034,
	"./south/phangnga/phangnga-3.jpg": 73081,
	"./south/phangnga/phangnga-4.jpg": 29102,
	"./south/phangnga/phangnga-5.jpg": 5538,
	"./south/phangnga/phangnga-thumb.jpg": 902,
	"./south/phatthalung/phatthalung-1.jpg": 522,
	"./south/phatthalung/phatthalung-2.jpg": 63100,
	"./south/phatthalung/phatthalung-3.jpg": 18559,
	"./south/phatthalung/phatthalung-thumb.jpg": 94262,
	"./south/phuket/phuket-1.jpg": 2457,
	"./south/phuket/phuket-2.jpg": 82649,
	"./south/phuket/phuket-3.jpg": 61778,
	"./south/phuket/phuket-4.jpg": 94621,
	"./south/phuket/phuket-5.jpg": 51412,
	"./south/phuket/phuket-thumb.jpg": 7843,
	"./south/ranong/ranong-1.jpg": 21509,
	"./south/ranong/ranong-2.jpg": 11354,
	"./south/ranong/ranong-3.jpg": 10842,
	"./south/ranong/ranong-4.jpg": 16522,
	"./south/ranong/ranong-5.jpg": 88505,
	"./south/ranong/ranong-5_LAPTOP-I9MLGHOK_May-17-160245-2023_Conflict.jpg": 32797,
	"./south/ranong/ranong-thumb.jpg": 32554,
	"./south/satun/satun-1.jpg": 21899,
	"./south/satun/satun-2.jpg": 85038,
	"./south/satun/satun-3.jpg": 30170,
	"./south/satun/satun-4.jpg": 86814,
	"./south/satun/satun-thumb.jpg": 21806,
	"./south/songkhla/songkhla-1.jpg": 90570,
	"./south/songkhla/songkhla-2.jpg": 99880,
	"./south/songkhla/songkhla-3.jpg": 79672,
	"./south/songkhla/songkhla-4.jpg": 50275,
	"./south/songkhla/songkhla-5.jpg": 29974,
	"./south/songkhla/songkhla-thumb.jpg": 13203,
	"./south/surat-thani/surat-thani-1.jpg": 34295,
	"./south/surat-thani/surat-thani-2.jpg": 69870,
	"./south/surat-thani/surat-thani-3.jpg": 27150,
	"./south/surat-thani/surat-thani-4.jpg": 65025,
	"./south/surat-thani/surat-thani-thumb.jpg": 13719,
	"./south/trang/trang-1.jpg": 19935,
	"./south/trang/trang-2.jpg": 61816,
	"./south/trang/trang-3.jpg": 15813,
	"./south/trang/trang-4.jpg": 72294,
	"./south/trang/trang-5.jpg": 64943,
	"./south/trang/trang-thumb.jpg": 27008,
	"./south/yala/yala-1.jpg": 74236,
	"./south/yala/yala-2.jpg": 45104,
	"./south/yala/yala-3.jpg": 63438,
	"./south/yala/yala-4.jpg": 60436,
	"./south/yala/yala-5.jpg": 32185,
	"./south/yala/yala-thumb.jpg": 53675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92236;